import invariant from 'fbjs/lib/invariant.js';
import { getElementRectV2 } from '#/lib/get-element-rect.js';
import { IShapeGetter } from './shape-getter.interface';

export const shapeGetter: IShapeGetter = async function (
  widgetDescription,
  selector,
) {
  const element = document.querySelector(selector);
  invariant(
    element,
    'ShapeGetter: Could not find element by selector: %s',
    selector,
  );
  const parent = document.getElementById(widgetDescription.slide.id);
  invariant(
    parent,
    'ShapeGetter: Could not find parent element by id: %s',
    widgetDescription.slide.id,
  );

  const { boundingClientRect, rootBounds } = await getElementRectV2(element, {
    root: parent,
  });
  return {
    width: boundingClientRect.width,
    height: boundingClientRect.height,
    top: Math.round(boundingClientRect.top - rootBounds.top),
    left: Math.round(boundingClientRect.left - rootBounds.left),
  };
};
